import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from '@env/environment';
import { CommonService } from './common.service';
 
import { map, catchError } from 'rxjs/operators';
import { HttpClient, HttpParams } from '@angular/common/http';
import { PageResponse } from '@app/models/page-response';
import { MerchantSettings, MerchantSettingsSearchingCriteria } from '@app/models/merchant-settings';

@Injectable()
export class MerchantSettingsService {

    constructor(
        private httpClient: HttpClient,
        private commonService: CommonService
    ) { }

    getAll(): Observable<MerchantSettings> {
        return this.httpClient.get(`${environment.API_END_POINT}/merchantSettings`, { headers: this.commonService.getHeaders() })
            .pipe(
                map(response => <MerchantSettings>(<any>response).content),
                catchError((error: Response | any) => this.commonService.handleHttpError(error))
            );
    }

    getByCode(systemParameterCode: string): Observable<MerchantSettings> {

        let params: HttpParams = new HttpParams();
        params = params.set('code', systemParameterCode);

        return this.httpClient.get(`${environment.API_END_POINT}/merchantSettings`, { headers: this.commonService.getHeaders(), params: params })
            .pipe(
                map(response => <MerchantSettings>(<any>response).content),
                catchError((error: Response | any) => this.commonService.handleHttpError(error))
            );
    }

    update(systemParameter: MerchantSettings): Observable<MerchantSettings> {

        let body = JSON.stringify(systemParameter);

        return this.httpClient.put(`${environment.API_END_POINT}/merchantSettings`, body, { headers: this.commonService.getHeaders() })
            .pipe(
                map(response => <MerchantSettings>(<any>response).content),
                catchError((error: Response | any) => this.commonService.handleHttpError(error))
            );

    }

    
    get(id: string): Observable<MerchantSettings> {
        return this.httpClient.get(`${environment.API_END_POINT}/merchantSettings/${id}`, { headers: this.commonService.getHeaders() })
            .pipe(
                map(response =>  {
                    let tempObj = <MerchantSettings>((<any>response).content);
                    return tempObj;
                }),
                catchError((error: Response | any) => this.commonService.handleHttpError(error))
            );
    }


    
  globalSearch(globalCriteria: string = '', criteria: MerchantSettingsSearchingCriteria, page: number = 0, size: number = 10, sortField: string, sortDirection: string = 'asc'): Observable<PageResponse<MerchantSettings>> {

    let params: HttpParams = new HttpParams();
    params = params.set('global', globalCriteria);
    params = params.set('criteria', JSON.stringify(criteria == null ? new MerchantSettingsSearchingCriteria() : criteria));
    params = params.set('page', page.toString());
    params = params.set('size', size.toString());
    if (sortField != null) {
        params = params.set('sort', sortField + ',' + sortDirection);
    }

    return this.httpClient.get(`${environment.API_END_POINT}/merchantSettings`, { headers: this.commonService.getHeaders(), params: params })
        .pipe(
            map(response => {
                let tempObj = <MerchantSettings[]>(<any>response);
                return tempObj;
            }),
            catchError((error: Response | any) => this.commonService.handleHttpError(error))
        );
} 
}